// Mock locations data for SearchPanel testing
// In production, this would come from the database

export interface Location {
  id: string
  name: string
  slug: string
  latitude: number
  longitude: number
}

export const mockLocations: Location[] = [
  {
    id: "1",
    name: "Casablanca",
    slug: "casablanca",
    latitude: 33.5731,
    longitude: -7.5898
  },
  {
    id: "2", 
    name: "Rabat",
    slug: "rabat",
    latitude: 34.0209,
    longitude: -6.8416
  },
  {
    id: "3",
    name: "Marrakech",
    slug: "marrakech", 
    latitude: 31.6295,
    longitude: -7.9811
  },
  {
    id: "4",
    name: "Fès",
    slug: "fes",
    latitude: 34.0181,
    longitude: -5.0078
  },
  {
    id: "5",
    name: "Tanger",
    slug: "tanger",
    latitude: 35.7595,
    longitude: -5.8340
  },
  {
    id: "6",
    name: "Agadir",
    slug: "agadir",
    latitude: 30.4278,
    longitude: -9.5981
  },
  {
    id: "7",
    name: "Oujda",
    slug: "oujda",
    latitude: 34.6867,
    longitude: -1.9114
  },
  {
    id: "8",
    name: "Kenitra",
    slug: "kenitra",
    latitude: 34.2610,
    longitude: -6.5802
  },
  {
    id: "9",
    name: "Tetouan",
    slug: "tetouan",
    latitude: 35.5889,
    longitude: -5.3626
  },
  {
    id: "10",
    name: "Safi",
    slug: "safi",
    latitude: 32.2994,
    longitude: -9.2372
  },
  {
    id: "11",
    name: "Meknès",
    slug: "meknes",
    latitude: 33.8935,
    longitude: -5.5473
  },
  {
    id: "12",
    name: "Azrou",
    slug: "azrou",
    latitude: 33.4347,
    longitude: -5.2217
  }
]
